<template>
    <div>
        <page-header :title="$t('pages.subscription.start.title')" icon-class="mdi mdi-home"/>


        <div class="row">
            <div class="col-12 grid-margin stretch-card">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>

                        <i class="mdi mdi-spin mdi-autorenew mdi-48px text-primary" v-if="!step"></i>

                        <transition name="component-fade" mode="out-in">
                            <static-loading-indicator-icon v-if="!step"></static-loading-indicator-icon>
                            <subscription-start-address v-if="step === 1" @step-completed="$refs.stepper.next()"></subscription-start-address>
                            <subscription-start-questions v-if="step === 2" @step-completed="$refs.stepper.next()"></subscription-start-questions>
                            <subscription-start-billing v-if="step === 3"></subscription-start-billing>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VStepper from '../../Includes/Stepper/Stepper'
import PageHeader from "../../Includes/PageHeader";
import SubscriptionStartAddress from "./SubscriptionStartAddress";
import SubscriptionStartQuestions from "./SubscriptionStartQuestions";
import SubscriptionStartRepository from "../../../repositories/Subscription/SubscriptionStartRepository";
import SubscriptionStartBilling from "./SubscriptionStartBilling";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";
export default {
    name: "SubscriptionStepper",
    components: {
        StaticLoadingIndicatorIcon,
        SubscriptionStartBilling, SubscriptionStartQuestions, SubscriptionStartAddress, PageHeader, VStepper},
    data: () => ({
        steps: 3,
        step: 0
    }),
    mounted() {
        SubscriptionStartRepository
            .getStep()
            .then((res) => {
                switch(res.data.step) {
                    case "STEP_ADDRESS":
                        this.step = 1;
                        break;
                    case "STEP_HEALTH_QUESTIONS":
                        this.step = 2;
                        break;
                    case "STEP_BILLING":
                        this.step = 3;
                        break;
                    case "STEP_SUBSCRIPTION_COMPLETED":
                        this.$router.push({name: 'home'});
                        break;
                }
            });
    },
}
</script>

<style scoped>

</style>
